const CORPORATE = "https://quantarock.in";

// Mirrors the corporate footer on quantarock.in: a brand blurb and a single
// green CTA beneath the contact details.
export const FOOTER_TAGLINE =
  "Enterprise servers, storage and networking hardware, supplied and supported by QuantaRock Systems.";

export const FOOTER_CTA = {
  label: "Request a quote",
  url: `${CORPORATE}/contact`,
};

// Shop links stay local; anything about the company deep-links into
// quantarock.in rather than dropping visitors on its homepage.
export const Footer_MENU_LIST = [
  {
    title: "Shop",
    links: [
      { name: "All Products", pageId: "/all-products" },
      { name: "Certifications", pageId: "/certifications" },
    ],
  },
  {
    title: "Buying from us",
    links: [
      { name: "Delivery & shipping", pageId: "/policies/delivery" },
      { name: "Returns & RMA", pageId: "/policies/returns" },
      { name: "Warranty terms", pageId: "/policies/warranty" },
    ],
  },
  {
    title: "Legal",
    links: [
      { name: "Terms of use", pageId: "/legal/terms" },
      { name: "Privacy policy", pageId: "/legal/privacy" },
      { name: "Cookie policy", pageId: "/legal/cookies" },
    ],
  },
  {
    title: "QuantaRock",
    external: true,
    links: [
      { name: "About the company", pageId: `${CORPORATE}/company/about-us` },
      { name: "Services", pageId: `${CORPORATE}/services/pri_solutions` },
      { name: "Data centers", pageId: `${CORPORATE}/data-centers` },
      { name: "Blog", pageId: `${CORPORATE}/resources/blogs` },
      { name: "Careers", pageId: `${CORPORATE}/company/careers` },
      { name: "Contact us", pageId: `${CORPORATE}/contact` },
    ],
  },
];
